/// <reference types="@types/google.maps" />
import { Injectable } from '@angular/core';
import { GeoCoords, MapsService } from './maps.service';

export interface MarkerSet {
  [groupName: string]: MarkerGroup;
}

export interface MarkerGroup {
  [markerId: string]: google.maps.Marker;
}

@Injectable({
  providedIn: 'root'
})
export class MapMarkerService {
  private _markerSet: MarkerSet = {};
  private _map: google.maps.Map;
  constructor(private mapsService: MapsService) {}

  get map(): google.maps.Map {
    return this._map;
  }

  set map(map: google.maps.Map) {
    this._map = map;
  }

  // get set
  getMarkerSet(): MarkerSet {
    return this._markerSet;
  }

  // get group
  getMarkerGroup(groupName: string): MarkerGroup {
    return this._markerSet[groupName];
  }

  // get marker
  getMarker(groupName: string, markerId: string): google.maps.Marker {
    return this._markerSet[groupName][markerId];
  }

  // create marker
  createMarker(groupName: string, markerId: string, markerLocation: GeoCoords, iconUrl: string, zIndex?: number): google.maps.Marker {
    this._markerSet[groupName][markerId] = this.mapsService.buildNodeMarker({
      location: markerLocation,
      map: this._map,
      color: iconUrl,
      zIndex: zIndex
    });
    return this._markerSet[groupName][markerId];
  }

  // create marker group
  createMarkerGroup(groupName: string): MarkerGroup {
    return (this._markerSet[groupName] = {});
  }

  // move marker
  updateMarkerPosition(groupName: string, markerId: string, position: GeoCoords): google.maps.Marker {
    this._markerSet[groupName][markerId].setPosition({ lat: position.lat, lng: position.lng });
    return this._markerSet[groupName][markerId];
  }

  // hide or show marker
  setMarkerVisible(groupName: string, markerId: string, visible: boolean): void {
    this._markerSet[groupName][markerId].setVisible(visible);
  }

  // change marker icon
  updateMarkerIcon(groupName: string, markerId: string, iconUrl: string): google.maps.Marker {
    this._markerSet[groupName][markerId].setIcon(iconUrl);
    return this._markerSet[groupName][markerId];
  }

  // remove marker from group and map
  deleteMarker(groupName: string, markerId: string): boolean {
    this._markerSet[groupName][markerId].setMap(null);
    return delete this._markerSet[groupName][markerId];
  }

  // delete group
  deleteGroup(groupName: string): boolean {
    Object.keys(this._markerSet[groupName]).forEach(key => {
      this._markerSet[groupName][key].setMap(null);
    });
    this._markerSet[groupName] = {};
    return true;
  }
}
